export const services = [
  {
    name: 'Decorate',
    one: 'Space Transformation',
    two: 'Centerpieces',
    three: 'Ceiling installation'
  },{
    name: 'Plan',
    one: 'Full planning',
    two: 'Month of Coordination',
    three: 'Day of Coordination'
  },
  {
    name: 'Design',
    one: 'Vision Board',
    two: 'Mock Presentation',
    three: '3D Rendering'
  },
]




export const events = [
  "sapphire",
  "rose gold",
  "emerald",
  "weddings",
  "diamond",
  "platinum",
]